import {on} from 'delegated-events'
import {observe} from '@github/selector-observer'

// This is the keep the toggle switch checked when clicked. The toggle switch is not a real toggle switch, but to show that SSO is enabled.
on('click', '.js-business-sso-configuration-status', element => {
  const status = element.currentTarget
  const button = status.querySelector<HTMLElement>('button')!
  status.className += ' ToggleSwitch--checked'
  button.setAttribute('aria-pressed', 'true')
})

// This is to allow the SSO toggle switch to activate the confirmation dialog
observe('.js-business-sso-configuration-status button', element => {
  const dialogId = 'sso-configuration-status'
  element.setAttribute('id', `dialog-show-${dialogId}`)
  element.setAttribute('data-show-dialog-id', dialogId)
})
